import React, { PureComponent } from "react";
import FlexView from "react-flexview";
import { withMedia } from "react-media-query-hoc";
import * as clipboard from "clipboard-polyfill";
import qs from "qs";
import { withRouter } from "react-router";

import {
  Logo,
  AppleMailLogo,
  Paragraph,
  VideoLink,
  FormInput,
  SignatureInput,
  Button
} from "../../components";

const macMail = "mac-mail";
const macOutlook = "mac-outlook";
const whitelistedClients = [macMail, macOutlook];

class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      sealLink: "",
      sealLinkError: null,
      sealLinkValidated: null,
      certLink: "",
      certLinkError: null,
      certLinkValidated: null,
      showIframe: false,
      loadingIFrame: false,
      copiedNotice: false,
      client: null
    };
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentWillMount() {
    const { match, location, history } = this.props;
    const parsed = qs.parse(location.search.slice(1));
    let client = "mac-mail";
    if (parsed.client && whitelistedClients.includes(parsed.client)) {
      client = parsed.client;
    }
    this.setState({
      client: client
    });

  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown, false);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown, false);
  }

  handleChange(e) {
    this.setState({
      [e.target.id]: e.target.value
    });
  }

  sealLinkUrlValidate(value) {
    // ffffc7f6-c0ba-4efa-b14a-080a9204262c
    const checker = /^https:\/\/seals\.prod\.privyseal\.io\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/gm.test(
      value
    );
    this.setState({
      sealLinkError: !checker
        ? "Doesn't seem like a valid PrivySeal seal url"
        : null,
      sealLinkValidated: true
    });
  }

  certLinkUrlValidate(value) {
    const checker = /^https:\/\/credentials\.prod\.privyseal\.io\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/gm.test(
      value
    );
    this.setState({
      certLinkError: !checker
        ? "Doesn't seem like a valid PrivySeal certificate url"
        : null,
      certLinkValidated: true
    });
  }

  generateSeal() {
    this.setState({
      loadingIFrame: true
    });
    setTimeout(() => {
      this.setState({
        showIframe: true,
        loadingIFrame: false
      });
    }, 2000);
  }

  setCopied() {
    this.setState({
      copiedNotice: true
    });
    setTimeout(() => {
      this.setState({
        copiedNotice: false
      });
    }, 2000);
  }

  handleKeyDown(event) {
    if (!this.state.showIframe) {
      return;
    }
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey && charCode === "c") {
      this.clippy();
    }
    // else if (event.ctrlKey && charCode === "v") {
    //   console.log("Ctrl + V pressed");
    // } else if (event.ctrlKey && charCode === "s") {
    //   event.preventDefault();
    //   console.log("Ctrl + S pressed");
    // }

    // For MAC we can use metaKey to detect cmd key

    if (event.metaKey && charCode === "c") {
      this.clippy();
    }
    // else if (event.metaKey && charCode === "v") {
    //   console.log("Cmd + V pressed");
    // } else if (event.metaKey && charCode === "s") {
    //   event.preventDefault();
    //   console.log("Cmd + S pressed");
    // }
  }

  macMailCopyData(certLink, sealLink) {
    const string = `<a href=${certLink}><img width="300px" height="auto" src=${sealLink} alt="My PrivySeal"/><span style="font-size: 0px;">My PrivySeal</span></a>`;
    // const encodedString = "data:text/html," + encodeURIComponent(string);
    // const data = `<div><span style="font-size: 0px;">My PrivySeal</span><iframe style="padding: 0px;" src=${encodedString} width="350px" height="auto" frameBorder="0"/></div>`;
    return string;
  }

  macOutlookCopyData(certLink, sealLink) {
    const data = `<html><a href=${certLink}><img width="300px" height="auto" src=${sealLink} alt="My PrivySeal"/></a></html>`;
    return data;
  }

  clippy() {
    const { certLink, sealLink, client } = this.state;
    let data;
    if (client === macOutlook) {
      data = this.macOutlookCopyData(certLink, sealLink);
    } else {
      data = this.macMailCopyData(certLink, sealLink);
    }
    console.log("data", data);
    const dt = new clipboard.DT();
    dt.setData("text/plain", data);
    dt.setData("text/html", data);
    clipboard.write(dt);
    this.setCopied();
  }

  // copyToClip() {
  //   const str = document.getElementById('seal-rtf').innerHTML;
  //   function listener(e) {
  //     e.clipboardData.setData("text/html", str);
  //     e.clipboardData.setData("text/plain", str);
  //     e.preventDefault();
  //   }
  //   document.addEventListener("copy", listener);
  //   const res = document.execCommand("copy");
  //   document.removeEventListener("copy", listener);
  //   console.log('res', res);
  //   return res;
  // };

  // clipper() {
  //   const clip = new ClipboardJS
  // }

  render() {
    const {
      sealLink,
      sealLinkError,
      certLink,
      certLinkError,
      showIframe,
      loadingIFrame,
      copiedNotice,
      certLinkValidated,
      sealLinkValidated
    } = this.state;

    const {
      media: { mobile, tablet, desktop, largeDektop }
    } = this.props;

    const desktopAndUp = desktop || largeDektop ? true : false;
    // const tabletDown = mobile || tablet ? true : false;

    const generateDisabled =
      certLink === "" ||
      certLinkError ||
      !certLinkValidated ||
      sealLink === "" ||
      sealLinkError ||
      !sealLinkValidated ||
      loadingIFrame;

    return (
      <FlexView
        column
        hAlignContent="center"
        style={{ paddingBottom: "350px" }}
      >
        <FlexView marginTop="60px">
          <Logo />
        </FlexView>
        {/* <FlexView marginTop="40px">
          <AppleMailLogo />
        </FlexView> */}
        <FlexView
          column
          width={desktopAndUp ? "70%" : "90%"}
          marginTop="60px"
          style={{ padding: "0 10%", textAlign: "center" }}
        >
          <Paragraph>
            Unfortunately Apple Mail has been historically unsupportive in
            enabling HTML email messages or html signatures.
          </Paragraph>
          <Paragraph>
            There are ways around it, but require knowledge of html and you have
            to jump through some technical hoops.
          </Paragraph>
          <Paragraph>
            We created the tool below, to enable you to copy and paste your seal
            into Apple Mail.
          </Paragraph>
        </FlexView>
        {/* <FlexView hAlignContent="center" marginTop="20px">
          <VideoLink />
        </FlexView> */}
        <FlexView
          width={desktopAndUp ? "40%" : "80%"}
          marginTop="60px"
          column
          style={{ boxSizing: "border-box" }}
        >
          <FormInput
            leadText="Step 1:"
            labelText="Paste your seal link"
            id="sealLink"
            handleChange={e => this.handleChange(e)}
            value={sealLink}
            placeholder="https://seals.prod.privyseal.io/your_holding_id"
            error={sealLinkError}
            validateFormat={() => this.sealLinkUrlValidate(sealLink)}
          />
        </FlexView>
        <FlexView
          width={desktopAndUp ? "40%" : "80%"}
          marginTop="40px"
          column
          style={{ boxSizing: "border-box" }}
        >
          <FormInput
            leadText="Step 2:"
            labelText="Paste your certificate link"
            id="certLink"
            handleChange={e => this.handleChange(e)}
            value={certLink}
            placeholder="https://credentials.prod.privyseal.io/your_holding_id"
            error={certLinkError}
            validateFormat={() => this.certLinkUrlValidate(certLink)}
          />
        </FlexView>
        <FlexView
          width={desktopAndUp ? "40%" : "80%"}
          marginTop="40px"
          hAlignContent="center"
          vAlignContent="center"
        >
          {showIframe ? (
            <div>
            <SignatureInput
              copiedNotice={copiedNotice}
              certLink={certLink}
              sealLink={sealLink}
              clippy={() => this.clippy()}
            />
            </div>
          ) : (
            <Button
              text="Generate seal"
              loading={loadingIFrame}
              handleClick={
                !generateDisabled ? () => this.generateSeal() : undefined
              }
              disabled={generateDisabled}
            />
          )}
        </FlexView>
      </FlexView>
    );
  }
}

export default withRouter(withMedia(Home));



// WEBPACK FOOTER //
// ./src/pages/Home/index.js